export const DEFAULT_LOCATION_TYPES = [
    { label: 'Branch', value: 'branch' },
    { label: 'Stockist', value: 'stockist' },
    { label: 'Warehouse', value: 'warehouse' },
    { label: 'Office', value: 'office' },
    { label: 'Click And Collect', value: 'click_and_collect' },
]

export const LOCATION_TYPE_OPTIONS = [
    { label: 'Locations', value: 'location' },
    { label: 'Location Types', value: 'location_type' },
    { label: 'Location Features', value: 'location_feature' },
]

export const formatDataForForm = data => {
    const types = data?.locationTypes?.reduce((d, t) => [...d, t.type], []) || []

    const formLocationFeatures = {}

    if (data?.locationFeatures?.length > 0) {
        data?.locationFeatures?.forEach(feature => {
            return (formLocationFeatures[feature['feature']] = true)
        })
    }

    return {
        ...data,
        locationTypes: types,
        formLocationFeatures,
        address1: data.address1 || data.line1 || '',
        address2: data.address2 || data.line2 || '',
        address3: data.address3 || data.line3 || '',
        address4: data.address4 || data.line4 || '',
    }
}

export const formatDataForApi = data => {
    const types = data?.locationTypes?.reduce((d, t) => [...d, { type: t }], []) || []
    const features = []

    if (data?.formLocationFeatures) {
        for (const [key, val] of Object.entries(data.formLocationFeatures)) {
            if (val === true) {
                features.push({ feature: key })
            }
        }

        delete data.formLocationFeatures
    }

    const dataClone = {
        ...data,
        locationTypes: types,
        locationFeatures: features,
        locationPageStatus: data.locationPageStatus || 'active',
        longitude: parseFloat(data.longitude),
        latitude: parseFloat(data.latitude),
    }

    if (data?.locationImages?.length > 0) {
        dataClone.locationImages = data.locationImages.map((image, idx) => {
            return {
                ...image,
                sortOrder: idx + 1,
            }
        })
    }

    if (!!data?.email === false) {
        dataClone.email = null
    }

    return {
        ...dataClone,
        line1: dataClone.address1 || '',
        line2: dataClone.address2 || '',
        line3: dataClone.address3 || '',
        line4: dataClone.address4 || '',
    }
}

export const formatDuplicatedData = data => {
    const dataClone = { ...data }

    dataClone.alias = data?.alias?.length > 0 ? `copy-of-${data.alias}` : ''
    dataClone.name = `Copy of ${data.name}`
    delete dataClone['@id']
    delete dataClone['@context']
    delete dataClone['@type']
    delete dataClone['id']
    delete dataClone['createdAt']
    delete dataClone['modifiedAt']

    return dataClone
}
